import { fetchPost, fetchGet } from 'common';

const apiUri: string = process.env.REACT_APP_API_URI as string;

export const fetchCustomersService = (bearerToken: string) => {
  // TODO ?expires=Date.Now() is to prevent caching of the API result in IE11 which leads to unwanted behavior. There might be a better way to handle this.
  const customersTask = fetchGet(
    `${apiUri}/userusagereport/customers?expires=${Date.now()}`,
    bearerToken,
  );

  return customersTask;
};

export const fetchUserUsageReportsService = (
  searchRequest: any,
  bearerToken: string,
) => {
  const userUsageReportsTask = fetchPost(
    `${apiUri}/userusagereport/reports`,
    searchRequest,
    bearerToken,
  );

  return userUsageReportsTask;
};

export const fetchHasBillingInfoPermissions = (bearerToken: string) => {
  // TODO ?expires=Date.Now() is to prevent caching of the API result in IE11 which leads to unwanted behavior. There might be a better way to handle this.
  const hasBillingInfoPermissions = fetchGet(
    `${apiUri}/userusagereport/haspermissions?expires=${Date.now()}`,
    bearerToken,
  );

  return hasBillingInfoPermissions;
};

export const fetchExcelExportFile = (
  searchRequest: any,
  bearerToken: string,
) => {
  const getExcelExportFile = fetchPost(
    `${apiUri}/userusagereport/export`,
    searchRequest,
    bearerToken,
  );

  return getExcelExportFile;
};
